export const normalizeDebtEmailResults = (rawResults = {}, { payload } = {}) => {
  const payloadEmails = Array.isArray(payload?.emails_deudas) ? payload.emails_deudas : [];

  const successfulRaw = Array.isArray(rawResults.successful_details)
    ? rawResults.successful_details
    : Array.isArray(rawResults.successful_emails)
    ? rawResults.successful_emails
    : [];

  const failedRaw = Array.isArray(rawResults.failed_details)
    ? rawResults.failed_details
    : Array.isArray(rawResults.failed_emails)
    ? rawResults.failed_emails
    : [];

  const normalizeDetail = (detail = {}) => ({
    contractId:
      detail.contrato_id ||
      detail.contract_id ||
      detail.order_number ||
      detail.contract_number ||
      'Sin contrato',
    subscriber:
      detail.suscriptor || detail.subscriber || detail.name || detail.recipient || 'Suscriptor',
    email: detail.email || detail.address || detail.to || 'Sin email',
    error: detail.error || detail.status || detail.status_code ? String(detail.error || detail.status || detail.status_code) : null,
  });

  const successfulDetails = successfulRaw.map((detail) => normalizeDetail(detail));
  const failedDetails = failedRaw.map((detail) => normalizeDetail(detail));

  const totalFromSummary =
    rawResults.summary?.total_emails ??
    rawResults.total_emails ??
    payloadEmails.length ??
    successfulDetails.length + failedDetails.length;

  const successCount =
    rawResults.summary?.successful_count ??
    (typeof rawResults.successful_emails === 'number'
      ? rawResults.successful_emails
      : successfulDetails.length);

  const failedCount =
    rawResults.summary?.failed_count ??
    (typeof rawResults.failed_emails === 'number'
      ? rawResults.failed_emails
      : failedDetails.length);

  const message =
    rawResults.message ||
    rawResults.error ||
    'Resultado del envío de recordatorios de mora.';

  return {
    message,
    summary: {
      total_emails: totalFromSummary,
      successful_count: successCount,
      failed_count: failedCount,
    },
    successfulDetails,
    failedDetails,
  };
};
